import dayjs from "dayjs";
import { useState } from "react";
import { IChart } from "../../../../../@types/chart.type";
import iconDelete from "./../../../../../assets/_TrashIcon_gray.svg";
import { IconUnavailableCollaborators } from "../../../../../icons/IconUnavailableCollaborators";
import { GridBaseWidget } from "../../GridBaseWidget";
import { ColDef, IGetRowsParams } from "ag-grid-community";
import { getUnavailableResources } from "../../../../../services/api/widgets/widgetsService";
import { IApiResponse } from "../../../../../@types/api-response.type";
import { storageUserGet } from "../../../../../storage/storageUser";
import { IUnavailableResourcesDto } from "../../../../../@types/widgets.type";
import { CustomCellRendererProps } from "ag-grid-react";
import styles from "./styles.module.scss";

interface UnavailableResourcesProps {
  chart: IChart;
  ismodeEdit: boolean;
  deleteChart: (id: string | undefined, widgetId: string) => void;
  rowHeightGrid: number;
}

const columns: ColDef[] = [
  {
    field: "id",
    headerName: "ID",
    hide: true,
  },
  {
    field: "resourceName",
    headerName: "Nome",
    flex: 1,
  },
  {
    field: "reason",
    headerName: "Motivo",
    flex: 1,
  },
  {
    field: "returnDate",
    headerName: "Data para retorno",
    flex: 1,
    cellRenderer: (params: CustomCellRendererProps) => {
      return dayjs(params.value).format("DD/MM/YYYY");
    },
  },
];

export function UnavailableResources({
  chart,
  deleteChart,
  ismodeEdit,
}: UnavailableResourcesProps) {
  const [loading, setLoading] = useState<boolean>(false);

  const user = storageUserGet();

  async function fetchUnavailableResources(params: IGetRowsParams) {
    const paramsBody = {
      managerId: user?.resourceId as string,
      skip: params.startRow, // Linha inicial para paginação
      take: params.endRow - params.startRow, // Quantidade de linhas
    };

    try {
      setLoading(true);
      const response = (await getUnavailableResources(
        paramsBody
      )) as IApiResponse<IUnavailableResourcesDto>;

      if (response.statusCode === 200) {
        params.successCallback(
          response.result.items,
          response.result.totalRows
        );
      }
    } catch (error) {
      console.log(error);
      params.failCallback();
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={styles.widget}>
      <div className={styles.header}>
        <h3>
          <IconUnavailableCollaborators size={26} />
          Meus Colaboradores Indisponíveis
        </h3>
      </div>
      <div style={{ width: "100%", height: "100%" }}>
        <GridBaseWidget
          columns={columns}
          fetchData={fetchUnavailableResources}
          loading={loading}
        />
      </div>
      {ismodeEdit && (
        <button onClick={() => deleteChart(chart.id, chart.widgetId)}>
          <img src={iconDelete} alt="" />
        </button>
      )}
    </div>
  );
}
